import { Component, OnInit, OnDestroy } from '@angular/core';
import { AccessoryLocalService } from '../../../shared/service/accessory-local.service';
import { AccessoryAmountService } from '../../../shared/service/accessory-amount.service';
import { CLEAN_ACCESSORIES } from '../../../core/actions';
import { AccessoryLocal } from '../../../shared/model/accessory-local';
import { AccessoryAmount } from '../../../shared/model/accessory-amount';
import { NgRedux } from '@angular-redux/store';
import { ArgosState } from '../../../core/argos-state';
import { Movement } from '../../../shared/model/movement';
import { Location } from '@angular/common';
import { ToastService } from '../../../shared/service/toast.service';

@Component({
  selector: 'tx-accessory-control',
  templateUrl: './accessory-control.component.html',
  styleUrls: ['./accessory-control.component.css']
})
export class AccessoryControlComponent implements OnInit, OnDestroy {

  locals: Array<AccessoryLocal>;
  selectedLocal: AccessoryLocal;
  accessories: Map<string, Array<AccessoryAmount>>;
  pageNumber = 0;
  pageSize = 5;

  constructor(private ngRedux: NgRedux<ArgosState>,
              private _accessoryLocalService: AccessoryLocalService,
              private _accessoryAmountService: AccessoryAmountService,
              private _location: Location,
              private _toastService: ToastService) {
    this.setUpObservers();
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  saveAmounts(amounts) {
    const editedAmounts = this.ngRedux.getState().editedAmounts;
    this._accessoryAmountService.move(new Movement(amounts, editedAmounts));
  }

  cancel() {
    this.cleanState();
  }

  findLocals(pageConfig?) {
    if (pageConfig && pageConfig.localName) {
      this._accessoryLocalService
        .findByNameContains(pageConfig.localName, pageConfig.pageNumber, pageConfig.pageSize);
    } else {
      try {
        this._accessoryLocalService
          .findLocals(pageConfig.pageNumber, pageConfig.pageSize);
      } catch (e) {
        this._accessoryLocalService
          .findLocals(this.pageNumber, this.pageSize);
      }
    }
  }

  findLocalAccessories(local: AccessoryLocal) {
    this.selectedLocal = local;
    this._accessoryAmountService.findAccessoryAmount(this.selectedLocal);
  }

  private setUpObservers() {
    this._accessoryAmountService.move$
      .subscribe(() => {
        this.cleanState();
      });

    this._accessoryAmountService.error$
      .subscribe(error => this.showMessage(error));

    this.setUpFindLocalAction();
    this.setUpFindAmountAction();
  }

  private setUpFindLocalAction() {
    this._accessoryLocalService.find$
      .filter(locals => locals instanceof Array)
      .subscribe(locals => this.locals = locals);
  }

  private setUpFindAmountAction() {
    this._accessoryAmountService.find$
      .filter(accessories => accessories instanceof Map)
      .subscribe(accessories => {
        this.accessories = accessories;
      });
  }

  private cleanState() {
    this.ngRedux.dispatch({ type: CLEAN_ACCESSORIES });
    this.selectedLocal = null;
    this.accessories = null;
  }

  private showMessage(message) {
    this._toastService.showMessage(message, 4000);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/accessory/component/accessory-control/accessory-control.component.ts